import {Injectable} from '@angular/core';
import {SharedModalUtils} from '../../../shared/shared-utils/shared-modal/shared-modal.utils';
import {
  buildDynamsoftLicenceFailureModalProps,
  isDynamsoftLicenceError,
} from '../utils/dynamsoft-licence.utils';

/**
 * Shows a user-facing modal when Dynamsoft licence initialisation fails.
 * Deduplicates so preload and the scanner overlay cannot stack the same warning.
 */
@Injectable({
  providedIn: 'root',
})
export class DynamsoftLicenceNotificationService {
  private hasPresented = false;
  private isPresenting = false;

  constructor(private readonly sharedModalUtils: SharedModalUtils) {
  }

  /**
   * Presents the licence-failure modal at most once per session when `error` is a Dynamsoft licence failure.
   *
   * @param {unknown} error - Value thrown by Dynamsoft.
   * @returns {Promise<boolean>} True when `error` is a licence failure, even if the modal was already shown.
   */
  async notifyIfLicenceError(error: unknown): Promise<boolean> {
    if (!isDynamsoftLicenceError(error)) {
      return false;
    }

    if (this.hasPresented || this.isPresenting) {
      return true;
    }

    this.isPresenting = true;
    this.hasPresented = true;
    try {
      await this.sharedModalUtils.createModal(buildDynamsoftLicenceFailureModalProps(error));
      return true;
    } finally {
      this.isPresenting = false;
    }
  }
}
